import { render, staticRenderFns } from "./UploaderFile.vue?vue&type=template&id=401db9c8&scoped=true&"
import script from "./UploaderFile.vue?vue&type=script&lang=js&"
export * from "./UploaderFile.vue?vue&type=script&lang=js&"
import style0 from "./UploaderFile.vue?vue&type=style&index=0&id=401db9c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401db9c8",
  null
  
)

export default component.exports